import {AppType} from '@web-catalog/types';

import {baseLog, logTmrEvent} from '@web-catalog/utils/analytics';

export const log = {
  allAppsClick: (alreadyActive: boolean) => {
    logTmrEvent({
      logEvent: 'allApps.click',
      params: {
        screen_name: 'apps',
      },
    });

    baseLog.catalogCategoryClick(AppType.MAIN, alreadyActive);
  },

  allGamesClick: (alreadyActive: boolean) => {
    logTmrEvent({
      logEvent: 'allGames.click',
      params: {
        screen_name: 'gameCategory',
      },
    });

    baseLog.catalogCategoryClick(AppType.GAMES, alreadyActive);
  },

  appCategorySelect: (appCategoryName: string, alreadyActive: boolean) => {
    logTmrEvent({
      logEvent: 'appCategory.select',
      params: {
        screen_name: 'appCategory',
        app_category_name: appCategoryName,
      },
    });

    baseLog.catalogCategoryClick(AppType.MAIN, alreadyActive);
  },

  gameCategorySelect: (gameCategoryName: string, alreadyActive: boolean) => {
    logTmrEvent({
      logEvent: 'gameCategory.select',
      params: {
        screen_name: 'gameCategory',
        app_category_name: gameCategoryName,
      },
    });

    baseLog.catalogCategoryClick(AppType.GAMES, alreadyActive);
  },
};
